
import React from 'react';
import { STATUSES, DEFAULT_STATE_VALUE,WindowState } from "Utils/constants";
import { useState, useEffect, useCallback, useRef} from "react";
import { Button, Fade } from 'react-bootstrap';
import { BackToTopButton, BackToTopButtonNew, IconButton } from 'Components/Button';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import { ICONS } from 'Utils/icons';

function BackToTop ({topRef}) {
    const [bttBottom, setBttBottom] = useState("10px");
    const [isBTTVisible,setIsBTTVisible]= useState(false);
    const bttRef=useRef(0);
    const [isVisibleHeight, setIsVisibleHeight] = useState(false);
    const [fadeClass, setFadeClass] = useState("fade-out");
    const [focusMain, setFocusMain] = useState(false);


    useEffect(() => {
        //console.log(isVisibleHeight);
        
        
    },[isVisibleHeight])

    const handleBTTButtonVisible = () => {  
        
        if(window.scrollY > 400) {
            if(isVisibleHeight!=true){
                setIsVisibleHeight(true);
            }
            //setIsBTTVisible(true);
        }
        else{
            if(isVisibleHeight==true){
                setIsVisibleHeight(false);
            }
            //setIsBTTVisible(false);
        }
    }
    window.addEventListener('scroll', handleBTTButtonVisible);


    const handleBTT = () => {
        if(topRef.current){
            topRef.current.focus();
        }
        setIsVisibleHeight(false);
    }

    return (
        <Fade in={isVisibleHeight} appear={true} mountOnEnter={true} unmountOnExit={true}>
            <div>
                <BackToTopButtonNew tabIndex={isVisibleHeight==true ? 0 : -1} onClick={handleBTT} variant="normal" icon={ICONS.btt} content={"Back To Top"}></BackToTopButtonNew>
            </div>
        </Fade>
    );
}

export default BackToTop;
